var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 17H4a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2ZM4 15a3 3 0 1 0 0 6h16a3 3 0 1 0 0-6H4Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4a1 1 0 1 0-2 0v5.586L9.707 8.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13 9.586V4Z",
    fill: "#777E91"
  })));
};
export default SvgLine;